import { IActionParam, IContract, LoanAgreement } from '@libs/models/models';
import { DocumentType } from '@libs/enums/document-param.emun';
import { CapacitorUtils } from '@libs/shared/capacitor/capacitor-utils';
import { saveAs } from 'file-saver';
import { VerificationTypeEnum } from '@libs/configs/component-configs/countdown.component-config';
import { ChannelMap, IChannelResponse } from '@libs/interfaces/channel.interface';

export const getValueNumber = (event: Event | number): number => {
  return typeof event === 'number' ? event : +(event.target as HTMLInputElement).value;
};

export const getCodeSMS = (value: string, verificationType: VerificationTypeEnum, hidePrefixSms: boolean): string => {
  let code = value;
  const typeSms: boolean = verificationType === VerificationTypeEnum.SMS || verificationType === VerificationTypeEnum.VIBER;
  if (typeSms) {
    const prefix: string = hidePrefixSms ? '' : 'W';
    code = `${prefix}${code}`;
  }
  return code;
};

export const buildPayload = (
  [contract, app, passport]: Array<IContract>,
  data: IActionParam,
  info: string[] = ['LOAN_SIGNING.APPLY', 'LOAN_SIGNING.PASSPORT', 'LOAN_SIGNING.CONTRACT', 'LOAN_SIGNING.SIGN'],
): LoanAgreement => {
  return {
    info,
    contracts: [
      { label: 'LOAN_AGREEMENT.APPLY_HEAD', content: app.content },
      { label: 'LOAN_AGREEMENT.PASSPORT_HEAD', content: passport.content },
      {
        label: 'LOAN_AGREEMENT.CONSUMER_HEAD',
        content: contract.content,
        buttonLabel: 'BUTTON.DOWNLOAD_CONTRACT',
        showButton: true,
        loadType: DocumentType.CONTRACT,
      },
    ],
    ...data,
  };
};

export const handleDocumentLoader = (response: IContract): void => {
  const blob = new Blob([response.content], { type: 'text/html' });
  if (CapacitorUtils.isApp) {
    CapacitorUtils.writeAndOpenFile(blob, 'document', 'pdf');
  } else {
    saveAs(blob, 'document.html');
  }
};

export const getCommissionAmount = (amount: number, interest: number, commissionRate: number, promoRate?: number): number => {
  const commissionAmount = (amount * commissionRate) / 100;
  const discountRate = getDiscount(interest, promoRate);
  const discountAmount = (commissionAmount * discountRate) / 100;
  return commissionAmount - discountAmount;
};

const getDiscount = (interest: number, promoRate: number): number => {
  return promoRate ? ((interest - promoRate) / interest) * 100 : 0;
};

export const getTomorrowMidnight = (): Date => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
};

export const typeSms = (type: VerificationTypeEnum): boolean => {
  return type === VerificationTypeEnum.SMS || type === VerificationTypeEnum.VIBER;
};

export const channelMapper = (data: IChannelResponse): ChannelMap => {
  const values = Object.values(VerificationTypeEnum) as VerificationTypeEnum[];

  const channels = values.reduce(
    (acc, channel) => {
      acc[channel] = data.channels.includes(channel);
      return acc;
    },
    {} as Record<VerificationTypeEnum, boolean>,
  );

  return {
    channel: data.defaultChannel as VerificationTypeEnum,
    channels,
  };
};
